import React, { useState, useEffect } from "react";
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import { Grid, Box, CircularProgress, Typography } from "@mui/material";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import { useSelector } from "react-redux";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { useGetTenantPicture } from '../../../CompanyManagment/Hooks/index';
import { UseGetAllTenantMission, useDeletePerson } from "../../Hooks/index";
import { Mission } from "../Mission/Mission";
import AddMission from "../AddMission/AddMission";
import EditMission from "../EditMission/EditMission";
import AllStrategy from "../AllStrategy/AllStrategy";
import TenantImageSelector from '../../../../components/GlobalComponents/ImageTenantSelector/ImageTenantSelectorr';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
const AllMission = ({ perData, periodId }: any) => {
  const userId = useSelector((state: any) => state.loign.userInfo.userId);
  const userPhoneNumber = useSelector((state: any) => state.loign.userPhoneNumber);
  const tenantId: string | null = useSelector((state: any) => state.meetings.profileTenantId);
  const { data: usersData, isLoading: getAllPeronsLoading , refetch:getAgain} = UseGetAllTenantMission(tenantId, periodId);
  const [personId, setPersonId] = useState<string | null>(null);
  const [personIdFDelete, setPersonIdFDelete] = useState<string | null>(null);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const { mutate: deletePerson } = useDeletePerson();
  const [showAddStaff, setShowAddStaff] = useState<Boolean | null>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [userAsynOpcState, setUserAsyncOpState] = useState<any>(null);
  const [initData, setInitData] = useState<any>();
  const [initCode, setInitCode] = useState<any>();
  const { data: personPictureData } = useGetTenantPicture(tenantId);
  const [imgSrc, setImgSrc] = useState<string | null>(null);
  const [showImageSelector, setShowImageSelector] = useState<boolean>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  useEffect(() => {
    // Load image from localStorage on component mount
    const savedImage = localStorage.getItem('tenantImage');
    if (savedImage) {
      setImgSrc(savedImage);
    } else if (personPictureData) {
      setImgSrc(personPictureData.pictureBase64String || null);
      localStorage.setItem('tenantImage', personPictureData.pictureBase64String || '');
    }
  }, [personPictureData]);

  useEffect(() => {
    if (usersData) {
      const{data,metaData} : any = usersData  || {};
      const{appStatusCode}=metaData  || {};
      setInitData(data);
      setInitCode(appStatusCode);
    }
  }, [usersData]);

  useEffect(() => {
    if (personIdFDelete) {
      let deleteBody = {
        phoneNumber: userPhoneNumber,
        lastModifiedById: userId,
        userId: userId,
        tenantId: tenantId,
      };
      deletePerson(deleteBody);
    }
  }, [personIdFDelete]);

  const handleImageClick = () => {
    setShowImageSelector(true);
  };

  const handleImageChange = (newImgSrc: string) => {
    setImgSrc(newImgSrc);
    localStorage.setItem('tenantImage', newImgSrc); // Save to localStorage
    setShowImageSelector(false);
  };

  const handleToastMessage = (message: string) => {
    setShowToastMessage(true);
    setTimeout(() => setShowToastMessage(false), 3000); // Hide toast after 3 seconds
  };

  const handleImageSelectorClose = () => {
    setShowImageSelector(false);
  };
  const[imgSrrc,setImgSrrc]=useState<any>(null);

  useEffect(() => {
    
    if (personPictureData) {
      let{pictureBase64String}=personPictureData;
      setImgSrrc(pictureBase64String)
    }
      }, [personPictureData])
  // Check if there are no missions
  const noMissions = !initData || initData.length === 0;

  return (
    <Grid container>
      <Grid item xs={12} md={12} mx={2}>
        <Box display={'flex'} flexDirection={'row-reverse'} justifyContent={'end'}>
          <Box marginTop={1} marginBottom={2} marginRight={5}>
            <img
              src={imgSrrc}
              width={'150px'}
              style={{ borderRadius: '10%', boxShadow: '20px', cursor: 'pointer' }}
              onClick={handleImageClick}
            />
          </Box>
          {showImageSelector && (
            <Box>
              <TenantImageSelector
                setChangeImgData={handleImageChange}
                setShowToastMessage={handleToastMessage}
                onClose={handleImageSelectorClose}
              />
            </Box>
          )}
        </Box>

        {noMissions && initCode !== 7 && (
          <>
            <Box display={"flex"} flexDirection={"row-reverse"} py={1} px={2}>
              <Box>
                <DyButton
                  caption={"هدف نهایی"}
                  onClick={() => setShowAddStaff(true)}
                  color={"red"}
                  disbled={false}
                  variant={"contained"}
                  type={"button"}
                  bgColor={"#00387C"}
                />
              </Box>
            </Box>
            <Grid container>
              <Box width={'100%'} textAlign={'center'} p={2}>
                <Box>
                  <Typography textAlign={'center'} fontWeight={500} fontSize={'18px'} variant='body2'>
                    هدف نهایی در این دوره‌‌زمانی تعریف نشده است.
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </>
        )}

        {showAddStaff && (
          <ModalLyt
            showModal={showAddStaff}
            setShowModal={setShowAddStaff}
            height={500}
            width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"هدف نهایی"}
          >
            <AddMission
              onSuccesss={() => setShowAddStaff(false)}
              onClose={() => setShowAddStaff(false)}
              periodId={periodId}
              setShowToastMessage={setShowToastMessage}
              setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}

        {showEditModal && (
          <ModalLyt
            showModal={showEditModal}
            setShowModal={setShowEditModal}
            height={500}
            width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"هدف نهایی"}
          >
            <EditMission
              personId={personId}
              periodId={periodId}
              onClose={() => setShowEditModal(false)}
              initData={initData}
              onSuccess={getAgain}
              setShowToastMessage={setShowToastMessage}
              setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}
      </Grid>

      <Grid item xs={12} sm={12}>
        {getAllPeronsLoading ? (
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            width={"99%"}
            py={15}
            boxShadow={4}
            borderRadius={3}
            mx={"auto"}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box
            width={"100%"}
            display={"flex"}
            flexWrap={"wrap"}
            alignItems={"center"}
            justifyContent={"center"}
            px={2}
          >
            { initCode !== 7 ?
            initData &&
              initData.map((item: any, i: number) => {
                return (
                  <Grid item xs={12} sm={10}>
                   <Box
                    width={"100%"}
                    key={i}
                    sx={{
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        backgroundColor: "withesmoke",
                        // boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
                        // borderRadius: "12px",
                      },
                      padding: "10px", // Add padding to ensure content isn't cut off during hover
                    }}
                  >
                      <Mission
                        setShowEditModal={setShowEditModal}
                        setPersonId={setPersonId}
                        setPersonIdFDelete={setPersonIdFDelete}
                        item={item}
                        setShowToastMessage={setShowToastMessage}
                        setDeleteState={setUserAsyncOpState}
                      />
                    </Box>
                  </Grid>
                );
              }) :
              <Box> <Typography variant='body1' textAlign={'center'} fontSize={'20px'} fontWeight={700}>
             شما دسترسی به این قسمت را ندارید و باید لایسنس خود را ارتقا دهید
             </Typography></Box>
              }
          </Box>
        )}
      </Grid>

      {
        initCode !== 7 && (
          <Grid item xs={12}>
        <AllStrategy periodId={periodId} perData={perData} />
      </Grid>
        )
      }
      {showToastMessage && (
        <DYToastMessage
          isSuccess={userAsynOpcState?.isSuccess}
          message={userAsynOpcState?.metaData.message}
          setShow={setShowToastMessage}
          show={showToastMessage}
        />
      )}

      <Grid item xs={12}>
        <Box width={'100%'} height={'15px'} />
      </Grid>
    </Grid>
  );
};

export default AllMission;